import React from 'react';
import { Dialog, DialogContent, DialogContentText, DialogHeader } from '../dialog';
import { Button } from '../formikFormInputs';
import { Viewer } from "../Common";
import { initFalse } from "../../utils/constants";

interface AgreementProps {
  onCancel: any | Function;
  onConfirm: any | Function;
  show: boolean;
  dsUrl: string,
  loading: boolean,
}

const AgentAgreement = ({onCancel, onConfirm, show, dsUrl, loading}: AgreementProps) => {

  const loadingMsg = 'Signing document is being prepared. This could take some time so please be patient and don\'t close this window.';

  return (
    <Dialog open={show}
            maxWidth="md"
            aria-describedby="agreement-dialog"
            disableBackdropClick={!initFalse}
            disableEscapeKeyDown={!initFalse}
            fullWidth={!initFalse}
            keepMounted={!initFalse}
            onClose={onCancel}
    >
      <DialogHeader>
        Approved Agent Selling Agreement
      </DialogHeader>
      <DialogContent dividers>
        <DialogContentText id="agreement-dialog">
          <Viewer loading={loading} loadingMessage={loadingMsg} title="" url={dsUrl}/>
        </DialogContentText>
        <Button id="viewer_iframe_confirm" label="Confirm" onClick={onConfirm} style={{display: 'none'}}/>
      </DialogContent>
    </Dialog>
  );
};

export default AgentAgreement;
